import { render, staticRenderFns } from "./JourneyTwo.vue?vue&type=template&id=2a075c4d"
import script from "./JourneyTwo.vue?vue&type=script&lang=js"
export * from "./JourneyTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports